import { downloadFile } from './scripts/helpers.js';

window.getDocuments = function (type) {
    let wrap = document.querySelector('.certificates-items');
    let loader = document.querySelector('.loader-wrap');
    $.ajax({
        url: '/get-documents',
        dataType: 'json',
        type: 'POST',
        data: {
            type: type, //
        },
        success: function(json) {
            console.log(json);
            processingDocuments(json.data);
            wrap.classList.add('loaded');
            loader.hidden = true;
        }
    });
}

function processingDocuments(data) {
    let $certificates = $('div.certificates-items'),
        $documents = $('div.documentation-items');

    $.each(data, function (key, val) {
        let html,
        storage = $('input.env').data().storage;

        if (val.type_document === 'company_certificates') {
            html = makeCertificates(val, storage);
            $certificates.append(html);
        } else if (val.type_document === 'company_documents') {
            html = makeDocuments(val, storage);
            $documents.append(html);
        }
    });
    document.querySelectorAll('.download').forEach((each) => {

        each.addEventListener('click', downloadFile);
    });
}

function makeCertificates(val, storage) {
    const fileUrl = storage + encodeURIComponent(val.document_revision_id);

    return '<div class="certificates-item-wrap-outside">' +
        '<div class="certificates-item">' +
            '<a href="' + fileUrl + '" class="link-block" data-fancybox="gallery" data-caption="' + val.description + '">' +
                '<img src="' + fileUrl + '" alt="Здесь могла бы быть картинка :-(" onError="this.src=\'images/error/certificate-item.jpeg\'">' +
            '</a>' +
        '</div></div>'
        ;
}

function makeDocuments(val, storage) {
    const fileUrl = storage + encodeURIComponent(val.document_revision_id) +
        '?download=1&name=' + encodeURIComponent(val.revisions.filename);

    return '<div class="documentation-item-wrap-outside">' +
            '<div class="download documentation-item document-link-wrap" data-filename="' + val.revisions.filename + '" data-href="' + fileUrl + '">' +
            '<div class="img">' +
                '<i class="icon-list"></i>' +
            '</div>' +
            '<div class="title">' + val.document_name + '</div>' +
        '</div></div>'
        ;
}
